import config from '../../config'
import {
  valid,
  refreshToken,
  ajax,
  serviceAjax,
  header
} from './base'

const information = {
  // 通知公告
  async DelAnnouncement(data = {}) {
    const response = await serviceAjax({
      url: '/api/services/app/Announcement/Delete',
      type: 'post',
      data
    })
    return response
  },
  async CreateOrUpdateAnnouncement(data = {}) {
    const response = await serviceAjax({
      url: '/api/services/app/Announcement/CreateOrUpdate',
      type: 'post',
      data
    })
    return response
  },
  async GetAnnouncementList(data = {}) {
    const response = await serviceAjax({
      url: '/api/services/app/Announcement/GetPaged',
      type: 'post',
      data
    })
    return response
  },
  async GetAnnouncement(data = {}) {
    const response = await serviceAjax({
      url: '/api/services/app/Announcement/GetById',
      type: 'get',
      data
    })
    return response
  },
  async BatchPublishAnnouncement(data = {}) {
    const response = await serviceAjax({
      url: '/api/services/app/Announcement/BatchPublish',
      type: 'post',
      data
    })
    return response
  },
  // 反馈
  async GetFeedbackList(data = {}) {
    const response = await serviceAjax({
      url: '/api/services/app/Feedback/GetPaged',
      type: 'post',
      data
    })
    return response
  },
  async GetFeedback(data = {}) {
    const response = await serviceAjax({
      url: '/api/services/app/Feedback/GetById',
      type: 'get',
      data
    })
    return response
  },
  async FeedbackReply(data = {}) {
    const response = await serviceAjax({
      url: '/api/services/app/Feedback/Reply',
      type: 'post',
      data
    })
    return response
  },
  // 通知范围
  async DelAnnouncementScope(data = {}) {
    const response = await serviceAjax({
      url: '/api/services/app/AnnouncementScope/Delete',
      type: 'post',
      data
    })
    return response
  },
  async CreateOrUpdateAnnouncementScope(data = {}) {
    const response = await serviceAjax({
      url: '/api/services/app/AnnouncementScope/CreateOrUpdate',
      type: 'post',
      data
    })
    return response
  },
  async GetAnnouncementScopeList(data = {}) {
    const response = await serviceAjax({
      url: '/api/services/app/AnnouncementScope/GetPaged',
      type: 'post',
      data
    })
    return response
  },
}
export default information



// WEBPACK FOOTER //
// ./src/common/api/information.js